module.exports = __webpack_public_path__ + "ec4d5703bd9889c002f81210fdbde0dd.png";